import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const URL = `reports/status`;
export const getReportsStatus = (axios: IAxiosInstance) => {
  return async (
    params: ISchema["#/definitions/IGetReportsStatusQueryParams"]
  ) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetReportsStatusResponseBody"]
    >(URL, { params });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
